import React from "react";

import { NameEntity } from "../../helpers/NameEntity";
import FormField from "../form-field/FormField";

interface AssignedUser {
  assignedUser: NameEntity | null;
}

export default function DisplayAssignedUser(props: AssignedUser) {
  return (
    <FormField
      id="assigned-user"
      labelKey="DisplayAssignedUser.label"
      readOnly
      fieldValue={(props.assignedUser && props.assignedUser.name) || "-"}
    />
  );
}
